import { useState } from 'react';

export function useForm({ initialValues, onSubmit, validate }) {
  const [values, setValues] = useState(initialValues || {});
  const [errors, setErrors] = useState({});

  const handleSubmit = event => {
    event.preventDefault();
    onSubmit(values);
  };

  const handleChange = (fieldName, value) => {
    const error = validate(fieldName, value);
    setValues({
      ...values,
      [fieldName]: value,
    });
    setErrors({
      ...errors,
      [fieldName]: error,
    });
  };

  return { values, errors, handleSubmit, handleChange };
}



// WEBPACK FOOTER //
// ./src/hocs/useForm.jsx